import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { IChatListParams, IHttpResponse } from '@root/router/dialogue/chat-threads/http-interface';
import { Thread } from '@root/router/dialogue/chat-threads/thread.model';
import { User } from '@root/router/dialogue/chat-threads/user.model';
import { DateService } from '@root/shared/service/date.service';
import * as moment from 'moment';
interface IReadAllInquiry {
  thirdparty_type?: number;
}
interface UpdateChat {
  thread_id: string;
  is_top?: number;
  is_unfinished?: number;
}

export interface IChatListV2 {
  page: number;
  thirdparty_type?: number;
  is_unfinished?: number;
  is_unread?: number;
  reservation_status?: string;
  search_words?: string;
}

const CHAT_LIST_API = '/api/chat/chat_list';
const CHAT_LIST_API_V2 = '/api/chat/list';
const EXTEND_LIST_API = '/api/chat/extend_list';
const SYNCHRONIZE_API = '/api/chat/synchronize';
const THIRDPARTY_LIST_API = '/api/chat/had_thirdparty';
const HOUSE_THIRDPARTY_LIST_API = '/api/thirdparty/had_thirdparty';
const HOUSE_CALENDAR_THIRDPART_API = '/api/calendar/had_thirdparty';
const READ_ALL_INQUIRY_API = '/api/chat/read_all_inquiry';
const UPDATE_THREAD_API = '/api/chat/update';

const SYNC_HOUSE_ORIGIN_TIME = '/mobile_api/thirdparty/list';
const ZHENGUO_IM_STATUS_API = '/api/thirdparty/zhenguo_im_status';
@Injectable({
  providedIn: 'root',
})
export class ThreadService {
  activatedThread: Subject<Thread> = new Subject<Thread>();

  updatedThread: Subject<Array<Thread>> = new Subject<Array<Thread>>();
  sendMessageDone$: Subject<string> = new Subject();
  readAllThread$ = new Subject();
  requestStatus$: Subject<number> = new Subject();

  constructor(private http: HttpClient, private dateService: DateService) {}

  activate(thread: Thread) {
    if (!thread) {
      return;
    }
    this.activatedThread.next(thread);
  }

  update(threads: Array<Thread>) {
    this.updatedThread.next(threads);
  }

  sendMessageDone(threadId: string) {
    this.sendMessageDone$.next(threadId);
  }

  getSyncHouseOrigin(params) {
    return this.http.get(SYNC_HOUSE_ORIGIN_TIME, { params }) as Observable<IHttpResponse>;
  }

  /** @deprecated */
  getChatList(params: IChatListParams) {
    const query = new HttpParams()
      .append('thirdparty_type', `${params.thirdparty_type}`)
      .append('reservation_check_in', `${params.reservation_check_in}`)
      .append('reservation_check_out', `${params.reservation_check_out}`)
      .append('is_unfinished', `${params.is_unfinished}`)
      .append('reservation_status', `${params.reservation_status}`)
      .append('search_words', `${params.search_words}`)
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`);

    return this.http.get(CHAT_LIST_API, { params: query }) as Observable<IHttpResponse>;
  }

  getChatListV2(params: IChatListV2) {
    const query = new HttpParams({
      fromObject: {
        page: `${params.page}`,
        thirdparty_type: `${params.thirdparty_type}`,
        is_unfinished: `${params.is_unfinished}`,
        is_unread: `${params.is_unread}`,
        reservation_status: params.reservation_status,
        search_words: params.search_words,
      },
    });

    return this.http.get(CHAT_LIST_API_V2, { params: query }) as Observable<IHttpResponse>;
  }

  getChatListByThreadIds(params: { thread_ids: string }) {
    const query = new HttpParams().append('thread_ids', `${params.thread_ids}`);

    return this.http.get(CHAT_LIST_API_V2, { params: query }) as Observable<IHttpResponse>;
  }

  getThirdpartyList() {
    return this.http.get(THIRDPARTY_LIST_API) as Observable<IHttpResponse>;
  }

  getHouseThirdpartyList() {
    return this.http.get(HOUSE_THIRDPARTY_LIST_API) as Observable<IHttpResponse>;
  }

  getHouseCalendarThirdparty() {
    return this.http.get(HOUSE_CALENDAR_THIRDPART_API) as Observable<IHttpResponse>;
  }

  synchronize() {
    return this.http.get(SYNCHRONIZE_API) as Observable<IHttpResponse>;
  }

  updateThread(params: UpdateChat) {
    return this.http.post(UPDATE_THREAD_API, params) as Observable<IHttpResponse>;
  }

  fetchZhenguoIMStatus() {
    return this.http.get(ZHENGUO_IM_STATUS_API) as Observable<IHttpResponse>;
  }
  toThreadList(res: IHttpResponse): Array<Thread> {
    const list = (res && res.data && res.data.list) || [];
    return list.map((item) => {
      try {
        return new Thread({
          ...item,
          id: item.id,
          unread_count: item.unread_count,
          house_title: item.house_title,
          title_alias: item.title_alias,
          text_preview: item.text_preview,
          last_message_time: item.last_message_time,
          tenant_info: item.tenant_info ? new User(item.tenant_info) : new User({}),
          host_info: item.host_info ? new User(item.host_info) : new User({}),
          thirdparty_type: item.thirdparty_type,
          zhenguo_docking: item.zhenguo_docking,
          __relative_time: moment(item.last_message_time).isSame(moment(), 'day')
            ? this.dateService.format(item.last_message_time, [null, 'hm'])
            : this.dateService.format(item.last_message_time, ['MD']),
        });
      } catch (e) {
        return new Thread({});
      }
    });
  }

  readAllInquriy(params: IReadAllInquiry) {
    const query = new HttpParams().append('thirdparty_type', `${params.thirdparty_type}`);
    return this.http.get(READ_ALL_INQUIRY_API, { params: query }) as Observable<IHttpResponse>;
  }
}
